




import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { SkladOjetychVozu } from '@/modules/ojeteVozy/skladOjetychVozu';

import { store } from '../../store/edit';
import { types } from '../../store/types';

export default Vue.extend({
	name: 'ZakazkaOjeteVozidloSelect',
	components: {
		OjeteVozidloSelect: SkladOjetychVozu.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_OV_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.ZAKAZKA_OV_CHANGE}`,
			};
		},
	},
});
